import client from "api/client";

// F1 — mediaApi. Backed by website-scoped /websites/{websiteId}/media-assets.
// This is the module the editor (F3) and the useMediaUpload hook (F2) depend on
// for the 3-step upload flow. The website comes from the path, so `website_id`
// is never sent in bodies or query params.

// Step 1 of the 3-step upload — request a presigned blob URL.
// Returns GenerateUploadURLResponse { media_asset_id, upload_url, method,
// expires_at, required_headers }.
export const generateUploadUrl = async (
  websiteId,
  { originalFilename, fileSize, mimeType, visibility = "public", folderPath }
) => {
  const body = {
    original_filename: originalFilename,
    file_size: fileSize,
    mime_type: mimeType,
    visibility,
  };
  if (folderPath) body.folder_path = folderPath;
  const { data } = await client.post(`/websites/${websiteId}/media-assets/upload-url`, body);
  return data;
};

// Step 3 of the 3-step upload — confirm a finished upload.
// Returns the confirmed MediaAssetResponse { media_asset_id, file_url, ... }.
export const confirmUpload = async (
  websiteId,
  mediaAssetId,
  { altText, caption, description } = {}
) => {
  const body = {};
  if (altText !== undefined) body.alt_text = altText;
  if (caption !== undefined) body.caption = caption;
  if (description !== undefined) body.description = description;
  const { data } = await client.post(
    `/websites/${websiteId}/media-assets/${mediaAssetId}/confirm`,
    body
  );
  return data;
};

export const getMediaAsset = async (websiteId, id) => {
  const { data } = await client.get(`/websites/${websiteId}/media-assets/${id}`);
  return data;
};

// Paginated list — used by the featured-image picker and the Media library.
export const listMediaAssets = async (websiteId, { limit = 20, offset = 0 } = {}) => {
  const { data } = await client.get(`/websites/${websiteId}/media-assets`, {
    params: { limit, offset },
  });
  return { items: data.items ?? [], total: data.total ?? 0, hasMore: !!data.has_more };
};

// Edit an asset's metadata (alt text / caption / description).
export const updateMediaAsset = async (websiteId, id, { altText, caption, description } = {}) => {
  const body = {};
  if (altText !== undefined) body.alt_text = altText;
  if (caption !== undefined) body.caption = caption;
  if (description !== undefined) body.description = description;
  const { data } = await client.put(`/websites/${websiteId}/media-assets/${id}`, body);
  return data;
};

export const deleteMediaAsset = async (websiteId, id) => {
  await client.delete(`/websites/${websiteId}/media-assets/${id}`);
};
